import React from "react";

import pkg from "../../lib/pkg";
import { AnalyticsError } from "../../lib/util";
import useTrackEvent from "../useTrackEvent";

type WaitlistSeatClaimedMessageViewed = {
  sectionUid: string;
  currentUserUid?: string;
};

const EVENT_NAME = "Waitlist Seat Claimed Message Viewed";

export default function useWaitlistSeatClaimedMessageViewed() {
  const [tracked, setTracked] = React.useState<boolean>(false);
  const trackEvent = useTrackEvent();

  function track(
    waitlistSeatClaimedMessageViewed: WaitlistSeatClaimedMessageViewed
  ) {
    try {
      if (!tracked) {
        trackEvent(EVENT_NAME, waitlistSeatClaimedMessageViewed);
        setTracked(true);
      }
    } catch (error) {
      pkg.onError(new AnalyticsError(EVENT_NAME, error));
    }
  }
  return React.useCallback(track, [tracked, trackEvent]);
}
